module.exports = __webpack_public_path__ + "static/media/tab-img.94eff22f.jpg";